/**
 * Production Environment Configuration
 * Used for provisioning-admin.anepanywhere.com
 */

export const productionConfig = {
  environment: 'production',
  hostname: 'provisioning-admin.anepanywhere.com',

  api: {
    baseUrl: '/api',
    firmwareBaseUrl: 'https://provisioning.anepanywhere.com',
  },

  oauth: {
    clientId: 'provisioning-prod',
    redirectUri: 'https://provisioning-admin.anepanywhere.com/auth/callback',
    authUrl: 'https://keycloak.anepanywhere.com/realms/provisioning-anep/protocol/openid-connect/auth',
    tokenUrl: 'https://keycloak.anepanywhere.com/realms/provisioning-anep/protocol/openid-connect/token',
  },

  ui: {
    title: 'ANEP Device Provisioning',
    logoUrl: '/logo.png',
    companyName: 'ANEP',
    primaryColor: '#215EA1',
  },

  dev: {
    debug: false,
  },
} as const;

export default productionConfig;
